import React, { useState } from "react";
import ReactMapGL, {
  Source,
  Layer,
  Popup,
  FlyToInterpolator,
} from "react-map-gl";
import { easeCubic } from "d3-ease";
// eslint-disable-next-line import/no-webpack-loader-syntax
ReactMapGL.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

export default function App(props) {
  const [showPopup, togglePopup] = useState(false);
  const [viewport, setViewport] = useState(props.viewport);
  const layerStyle = {
    id: "polygons",
    type: "fill",
    paint: {
      "fill-color": [
        "interpolate",
        ["linear"],
        ["get", props.metric],
        100,
        "hsl(212, 95%, 92%)",
        199,
        "hsla(212, 68%, 59%, 0.79)",
        298,
        "hsl(212, 100%, 23%)",
      ],
      "fill-opacity": 1,
      "fill-outline-color": "hsla(0, 0%, 100%, 0.77)",
    },
  };
  const goToArea = (lngltd, info) => {
    // console.log(props);
    let boundCheck = info.features[0].layer.source;
    if (boundCheck === "my-data") {
      let properties = info.features[0].properties;
      props.getArea(properties.objectid, lngltd[0], lngltd[1]);
      setViewport({
        ...viewport,
        longitude: lngltd[0],
        latitude: lngltd[1],
        zoom: 12,
        transitionDuration: 2000,
        transitionInterpolator: new FlyToInterpolator(),
        transitionEasing: easeCubic,
      });
    }
  };


  return (
    <>
      <ReactMapGL
        // mapStyle={"mapbox://styles/coderhawk999/ckq2hdh1s1d7418mjiyc2ipd7"}
        {...props.viewport}
        minZoom={9.8}
        maxZoom={13}
        // dragPan={false}
        pinch={false}
        width="100%"
        height="100vh"
        mapboxApiAccessToken="pk.eyJ1IjoiY29kZXJoYXdrOTk5IiwiYSI6ImNrcTE1bXFwaDAzaXMyb29haTlqM3k2cHoifQ.u01_pEQqu_hWyO8gLGcpVA"
        onViewportChange={props.setViewport}
        onClick={(e) => {
          goToArea(e.lngLat, e);
        }}
      >
        {showPopup && (
          <Popup
            latitude={12.9716}
            longitude={77.5946}
            closeButton={true}
            closeOnClick={false}
            onClose={() => togglePopup(false)}
            anchor="top"
          >
            <div>You are here</div>
          </Popup>
        )}
        <Source id="my-data" type="geojson" data={props.areaGeaJson}>
          <Layer {...layerStyle} />
        </Source>

        {/* <MyrefComp /> */}
        <div className="overlay"></div>
      </ReactMapGL>
    </>
  );
}
